import { PurchaseMethods } from '@sm360/widget-commons-vehicle';

import * as catalogTypes from 'catalog/actions/catalogActionTypes.js';
import ManufacturerRecord from 'catalog/models/ManufacturerModel.js';
import * as ManufacturerService from 'catalog/services/ManufacturerService.js';

const { PurchaseMethodsActionsTypes } = PurchaseMethods;

export default function manufacturerReducer(state = new ManufacturerRecord(), action) {
    switch (action.type) {
        case catalogTypes.LOAD_MODELS_SUCCESS:
            return state.set('models', action.models);

        case catalogTypes.FILTER_BODY_STYLES:
            return ManufacturerService.filterBodyStyles(state, action.bodyStylesFilterCodes);

        case catalogTypes.FILTER_MAKE:
            return ManufacturerService.filterMake(state, action.make.value);

        case catalogTypes.FILTER_MODEL:
            return ManufacturerService.filterModel(state, action.modelSearchString);

        case PurchaseMethodsActionsTypes.SELECT_PURCHASE_METHOD:
            return ManufacturerService.selectPurchaseMethod(state, action.purchaseMethod);

        case PurchaseMethodsActionsTypes.SELECT_PAYMENT_FREQUENCY:
            return ManufacturerService.selectPaymentFrequency(state, action.paymentFrequency.value);

        case PurchaseMethodsActionsTypes.SET_TRADE_IN:
            return ManufacturerService.setTradeIn(state, action.tradeIn);

        case PurchaseMethodsActionsTypes.SET_LIEN:
            return ManufacturerService.setLien(state, action.lien);

        default:
            return state;
    }
}
